import { all, fork } from 'redux-saga/effects';
import watchUser from './services/user/saga';
import fetchSystemNotifications from './services/systemNotifications/saga';
import watchCompany from './services/company/saga';
import watchConfirmAction from './services/confirmAction/saga';
import watchChat from './services/chat/saga';
import 'babel-polyfill';

export default function* root() {
  yield all([
    fork(watchUser),
    fork(fetchSystemNotifications),
    fork(watchCompany),
    fork(watchConfirmAction),
    fork(watchChat),
  ]);
}



// WEBPACK FOOTER //
// ./src/rootSaga.js